export enum route {
  login = '/login',
  forgotPassword = '/forgot-password',
  dashboard = '/dashboard',
  dashboardNew = '/dashboard-new',
  verifyOtp = '/verify-otp',
  setPassword = '/reset-password',
  newPassword = '/register',
  forgotPasswordSuccess = '/forgot-password-success',
  invalidLinkPage = '/invalid-link',
  userManagement = '/user-management',
  onboarding = '/onboarding',
  profile = '/profile',
  venueSetup = '/venue-setup',
  sweeps = '/sweeps',
  harmReports = '/harm-reports',
  deletedHarmReports = '/deleted-harm-reports',
  interventionReports = '/intervention-reports',
}
